import { render, staticRenderFns } from "./WELogo.vue?vue&type=template&id=61e55402&scoped=true&"
import script from "./WELogo.vue?vue&type=script&lang=js&"
export * from "./WELogo.vue?vue&type=script&lang=js&"
import style0 from "./WELogo.vue?vue&type=style&index=0&id=61e55402&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e55402",
  null
  
)

export default component.exports